import React, { useMemo } from 'react';

import { Snippet } from '@distribute/shared/types';

import { SnippetsView } from './SnippetsView';
import { NoSnippetsFound } from './NoSnippetsFound';
import { getSnippets } from '../lib/getSnippets';
import { SORT_ITEMS } from '../lib';
import { FILTER_SNIPPET_ITEMS } from '../../../entities/snippets';

type SnippetsProps = {
  type: 'personal' | 'drafts';
  sort: keyof typeof SORT_ITEMS;
  filter: keyof typeof FILTER_SNIPPET_ITEMS;
  snippets: Snippet[];
};

export const Snippets: React.FC<SnippetsProps> = ({
  snippets,
  type,
  sort,
  filter,
}) => {
  const filteredSnippets = useMemo(
    () => getSnippets({ snippets, filter, sort }),
    [snippets, filter, sort]
  );

  return snippets.length > 0 ? (
    <>
      {filteredSnippets.length > 0 ? (
        <SnippetsView snippets={filteredSnippets} />
      ) : (
        <NoSnippetsFound type={type} />
      )}
    </>
  ) : (
    <NoSnippetsFound type={type} />
  );
};
